import { QueryClient } from "@tanstack/react-query";
import { queryClientConfig } from "~/common/config/queryClient";

export const queryClient = new QueryClient(queryClientConfig);
